<main class="complyon-sync-page">
  <section class="complyon-sync-connection" aria-label="Complyon connection status">
    <span class="complyon-sync-connection__icon" aria-hidden="true">
      <i class="bi bi-box-arrow-up-right"></i>
    </span>

    <div class="complyon-sync-connection__copy">
      <h2 class="complyon-sync-connection__title">Complyon connection &middot; healthy</h2>
      <p class="complyon-sync-connection__meta">
        Last handshake 38 seconds ago &middot; 412 items synced this week
      </p>
    </div>

    <span class="complyon-sync-connection__badge">
      <span class="complyon-sync-connection__dot"></span>
      Live
    </span>
  </section>

  <section class="complyon-sync-table-card" aria-labelledby="recently_synced_title">
    <header class="complyon-sync-table-card__header">
      <h2 id="recently_synced_title" class="complyon-sync-table-card__title">Recently synced</h2>
      <div class="d-flex align-items-center justify-content-end flex-wrap gap-2">
        <label class="onboarding-queue-search d-inline-flex align-items-center">
          <i class="bi bi-search" aria-hidden="true"></i>
          <input v-model="table_search" type="search" placeholder="Search table">
        </label>
        <span class="complyon-sync-table-card__range">7 DAYS</span>
      </div>
    </header>

    <div class="table-responsive">
      <table class="complyon-sync-table">
        <thead>
          <tr>
            <th scope="col">Item</th>
            <th scope="col">Type</th>
            <th scope="col">Onboarded Entity</th>
            <th scope="col">Direction</th>
            <th scope="col">At</th>
            <th scope="col">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="activity in filtered_sync_activity" :key="`${activity.item}-${activity.synced_at}`">
            <td class="complyon-sync-table__item">{{ activity.item }}</td>
            <td>{{ activity.type }}</td>
            <td>{{ activity.case_name }}</td>
            <td>{{ activity.direction }}</td>
            <td>{{ activity.synced_at }}</td>
            <td>
              <span :class="['complyon-sync__status', status_class(activity.status_tone)]">
                {{ activity.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</main>
